module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/4_b616ea1914949380913b1c8e54dc8cc0.png";